export default __webpack_public_path__ + "static/media/olajumokeowoeye.b4f78c6a.png";